import {http} from '../core/services/http'
import {ICreateVoucher, IUpdateVoucher, IUserSearchResult, IVoucher} from '../core/interfaces'
import {Pagination, PaginationParams} from '../core/services/utils'

export const getAllVouchers = (params?: PaginationParams) =>
    http.get<Pagination<IVoucher>>('/api/dashboard/vouchers', {params})

export const createVoucher = (data: ICreateVoucher) =>
    http.post<IVoucher>('/api/dashboard/vouchers', data)

export const updateVoucher = (id: string, data: IUpdateVoucher) =>
    http.put<IVoucher>(`/api/dashboard/vouchers/${id}`, data)

export const deleteVoucher = (id: string) =>
    http.delete(`/api/dashboard/vouchers/${id}`)

export const searchCreatorUsers = (q: string) =>
    http.get<IUserSearchResult[]>('/api/dashboard/vouchers/users/search', {params: {q}})
